/** Shared options for home search + property page filters (URL-synced). */

export const FILTER_AREA_DEFAULT = "";
export const AREAS = [
  { value: "", label: "Choose area" },
  { value: "Khobar", label: "Khobar" },
  { value: "Dammam", label: "Dammam" },
  { value: "Dhahran", label: "Dhahran" },
  { value: "Hofuf (Al-Ahsa)", label: "Hofuf (Al-Ahsa)" },
  { value: "Hafar al-Batin", label: "Hafar al-Batin" },
  { value: "Qatif", label: "Qatif" },
  { value: "Khafji", label: "Khafji" },
  { value: "Ras Tanura", label: "Ras Tanura" },
  { value: "Abqaiq", label: "Abqaiq" },
];

export const LISTING_FILTER = {
  ALL: "All",
  RENT: "Rent",
  SALE: "Sale",
  SOLD: "Sold",
};

export const LISTING_OPTIONS = [
  { value: LISTING_FILTER.ALL, label: "All listings" },
  { value: LISTING_FILTER.RENT, label: "For rent" },
  { value: LISTING_FILTER.SALE, label: "For sale" },
  { value: LISTING_FILTER.SOLD, label: "Sold" },
];

export const TYPE_DEFAULT = "";
export const PROPERTY_TYPE_OPTIONS = [
  { value: TYPE_DEFAULT, label: "All types" },
  { value: "APARTMENT", label: "Apartment" },
  { value: "VILLA", label: "Villa" },
  { value: "HOTEL", label: "Hotel" },
  { value: "LAND", label: "Land" },
  { value: "COMMERCIAL", label: "Commercial" },
];

export const PRICE_DEFAULT = "Any price";
export const SALE_MIN_PRICE_OPTION = "500,000 - 750,000 SAR";

export function priceOptionsForListing(listing) {
  if (listing === LISTING_FILTER.RENT) {
    return [
      PRICE_DEFAULT,
      "Under 10,000 SAR / month",
      "10,000 – 20,000 SAR / month",
      "20,000 – 40,000 SAR / month",
      "40,000+ SAR / month",
    ];
  }
  return [
    PRICE_DEFAULT,
    SALE_MIN_PRICE_OPTION,
    "750,000 – 1,000,000 SAR",
    "1,000,000 – 2,000,000 SAR",
    "2,000,000 – 3,000,000 SAR",
    "3,000,000 – 5,000,000 SAR",
    "5,000,000+ SAR",
  ];
}

/** @returns {null | { min?: number, max?: number }} */
export function parsePriceBand(label, listing) {
  if (!label || label === PRICE_DEFAULT) return null;
  if (listing === LISTING_FILTER.RENT) {
    if (label.startsWith("Under")) return { max: 10000 };
    if (label.includes("10,000")) return { min: 10000, max: 20000 };
    if (label.includes("20,000")) return { min: 20000, max: 40000 };
    if (label.includes("40,000+")) return { min: 40000 };
    return null;
  }
  if (label.startsWith("500,000")) return { min: 500000, max: 750000 };
  if (label.includes("750,000")) return { min: 750000, max: 1000000 };
  if (label.includes("1,000,000")) return { min: 1000000, max: 2000000 };
  if (label.includes("2,000,000")) return { min: 2000000, max: 3000000 };
  if (label.includes("3,000,000")) return { min: 3000000, max: 5000000 };
  if (label.includes("5,000,000+")) return { min: 5000000 };
  return null;
}

export function filtersFromSearchParams(searchParams) {
  return {
    area: searchParams.get("area") || "",
    listing: searchParams.get("listing") || LISTING_FILTER.ALL,
    type: searchParams.get("type") || TYPE_DEFAULT,
    price: searchParams.get("price") || PRICE_DEFAULT,
    q: searchParams.get("q") || "",
  };
}

export function searchParamsFromFilters(f) {
  const p = new URLSearchParams();
  if (f.area) p.set("area", f.area);
  if (f.listing && f.listing !== LISTING_FILTER.ALL) p.set("listing", f.listing);
  if (f.type) p.set("type", f.type);
  if (f.price && f.price !== PRICE_DEFAULT) p.set("price", f.price);
  if (f.q && f.q.trim()) p.set("q", f.q.trim());
  return p;
}

export function propertyMatchesFilters(property, f) {
  const price = Number(property.price || 0);
  const city = (property.city || "").toLowerCase();
  const areaField = (property.area || "").toLowerCase();
  const blob = [property.title, property.address, property.city, property.area, property.location]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  if (f.area) {
    const a = f.area.toLowerCase();
    if (!city.includes(a) && !areaField.includes(a) && !blob.includes(a)) return false;
  }

  if (f.listing === LISTING_FILTER.RENT) {
    if (String(property.listingType || "").toUpperCase() !== "RENT") return false;
  } else if (f.listing === LISTING_FILTER.SALE) {
    if (String(property.listingType || "").toUpperCase() !== "SALE") return false;
  } else if (f.listing === LISTING_FILTER.SOLD) {
    if (String(property.status || "").toUpperCase() !== "SOLD") return false;
  }

  if (f.type && String(property.type || "").toUpperCase() !== f.type.toUpperCase()) return false;

  if (f.listing !== LISTING_FILTER.ALL) {
    const band = parsePriceBand(f.price, f.listing);
    if (band) {
      if (band.min != null && price < band.min) return false;
      if (band.max != null && price > band.max) return false;
    }
  }

  if (f.q && f.q.trim()) {
    const q = f.q.trim().toLowerCase();
    if (!blob.includes(q)) return false;
  }

  return true;
}
